import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { countEmbeddedFiles } from '../../Templates/functions'
import { DEFAULT_PREVIEW_IMAGE, fileUrl } from '../../../util/file_url'
import moment from 'moment'
import Minimalistic from 'react-sortable-tree-theme-minimal';
import SortableTree from 'react-sortable-tree';
import { BuildClock, duplicateInstructionIcon, editInstructionIcon, ManageUsersIcon, previewInstructionIcon, deleteInstructionIcon } from '../../Templates/icons'
import Dialogue from '../../Templates/Dialogue'
import { cloneDeep } from 'lodash'

class WISummary extends Component {
    state = {
        treeData: this.props.workInstruction.steps || []
    }

    componentDidMount = () => {
      
        let page = document.getElementById("wi-page-content-container")
        page.addEventListener("keydown",this.stopTabScroll)
    }

    componentDidUpdate = (prevProps, prevState) => {
        // Update tree data after selecting another work instruction
        if (prevProps.workInstruction.steps !== this.props.workInstruction.steps) {
            this.setState({ treeData: this.props.workInstruction.steps || [] });
        }
    }


    componentWillUnmount = () => {

        let page = document.getElementById("wi-page-content-container")
        page.removeEventListener("keydown",this.stopTabScroll)
    }

    stopTabScroll=(e)=>{
        console.log("checking key pressed")
        if(e.keyCode == 9){
            e.preventDefault()
        }
    }

    updateContent = (content) => {
        let count = countEmbeddedFiles(content)
        if (count === 0) return content;
        // a space must be added after the content or else the regex expression will return 0 for last index.
        content = `${content} `
        //finds first instance of ![ and sets first index
        let firstIndex = content.search(/!\[/)
        //finds first insteads of .ext] and sets last index
        let lastIndex = content.search(/(:{2})*.]/)
        //replaces content inside of those indices for a clickable button
        let updatedContent = this.replaceContent(content, firstIndex, lastIndex)
        //calls function recursively to continue process with a new string containing a clickable button and remaining str
        return this.updateContent(updatedContent)
    }

    editWorkInstruction = (e, id, release, isAssignable, title) => {
        e.preventDefault();
        if (release && isAssignable) {
            if (window.confirm("The WI you are about to edit is already published and doing so will cause it to be unpublished. Are you sure you want to continue?") === true) {
                // Fetch the full WI data first
                this.props.fetchWorkInstructionForEdit(id).then(actionResult => {
                    // Safely access workInstruction data
                    const currentWorkInstruction = actionResult && actionResult.workInstruction ? actionResult.workInstruction : null;
                    if (!currentWorkInstruction) {
                        console.error("Failed to fetch work instruction data for editing. Action result:", actionResult);
                        alert("Error: Could not load work instruction data. Please try again.");
                        return;
                    }

                    // Clone and update the status to unpublished
                    const updatedWorkInstruction = cloneDeep(currentWorkInstruction);
                    updatedWorkInstruction.release = false;

                    // Save the unpublished state
                    this.props.saveWorkInstruction(updatedWorkInstruction).then(() => {
                        // Set the redux state for the author view with the unpublished data
                        this.props.setAuthorForEditing(updatedWorkInstruction);

                        // Navigate to the editor page
                        let url = `/dashboard/work instructions parent/${id + "~&~" + title}?pdf=${updatedWorkInstruction.isPDFViewer}`;
                        this.props.history.push(url);
                    }).catch(saveError => {
                        console.error("Error saving unpublished work instruction:", saveError);
                        alert("Error: Could not unpublish the work instruction. Please try again.");
                    });

                }).catch(fetchError => {
                    console.error("Error fetching work instruction for edit:", fetchError);
                    alert("Error: Could not load work instruction data. Please try again.");
                });
            }
        } else {
            this.props.selectWorkInstruction(id).then((actionResult) => {
                const workInstructionData = actionResult && actionResult.workInstruction ? actionResult.workInstruction : null;
                if (!workInstructionData) {
                    console.error("Failed to select work instruction data. Action result:", actionResult);
                    alert("Error: Could not load work instruction data. Please try again.");
                    return;
                }
                let url = `/dashboard/work instructions parent/${id + "~&~" + title}?pdf=${workInstructionData.isPDFViewer}`;
                this.props.history.push(url);
            }).catch(selectError => {
                console.error("Error selecting work instruction:", selectError);
                alert("Error: Could not load work instruction data. Please try again.");
            });
        }
    }

    previewWorkInstruction = (e, id) => {
        e.preventDefault()
        this.props.previewWorkInstruction(id).then((data) => {
            let url = `/dashboard/work instructions/preview/${id}?pdf=${data.workInstruction.isPDFViewer}`
            this.props.history.push(url)
        }
        );
    }

    deleteWorkInstruction = (e, id) => {
        e.stopPropagation();
        
        if (this.props.workInstruction.assignees > 0) {
            alert("This Work Instruction has assignees and cannot be deleted.");
            return;
        }
        
        this.setState({ 
            displayingDialogue: true,
            deletingWorkInstructionId: id  // Keep track of the ID of the Work Instruction to be deleted
        });
    }
    


    generateContent = (content) => {
        content = this.updateContent(content)

        let contentNode = (
            <div style={{ marginLeft: ".625em" }}
                id="step-preview-content"
                contentEditable={false}
                dangerouslySetInnerHTML={{ __html: content }}
            >
            </div>
        )
        return contentNode
    }


    parseDate = (MSSQLDate) => {
        let creationTimestampMs = Number(MSSQLDate);
        let formattedDate = moment.utc(creationTimestampMs).local(true).format("MM/DD/YYYY hh:mm A")
        //moment(creationTimestampMs).format('dddd, MMMM Do, YYYY');
        return formattedDate;
    }

    renderImage = () => {
        const defaultImage = fileUrl(DEFAULT_PREVIEW_IMAGE);
        // Fall back to the default image once. React keeps calling onError (clearing
        // e.target.onerror doesn't remove it), so without the check a missing default
        // image is requested over and over.
        return <img id="summary-thumbnail" src={fileUrl(this.props.workInstruction.preview_img || DEFAULT_PREVIEW_IMAGE)} alt="work instruction preview" onError={(e) => { if (e.target.src !== defaultImage) e.target.src = defaultImage; }} />
    }

    render() {
        let workInstruction = this.props.workInstruction
        let { release, isAssignable } = workInstruction
        const publicationPage = this.props.workInstruction.publication_page || {}
        const treeData = this.state.treeData
        // const assignedUsers = this.props.users.filter(user => user.assignments.some(assignment => assignment.wip_id === workInstruction.wip_id))
        return <div id="wi-page-content-container" className="flex-column shadow">
            {
                this.state.displayingDialogue ? (
                    <Dialogue
                        alert={
                            (workInstruction && workInstruction.assignees && workInstruction.assignees > 0)
                            ? "This Work Instruction has assignees and cannot be deleted."
                            : "You are about to delete a Work Instruction, this action cannot be undone. Would you like to proceed with the deletion?"
                        }
                        confirmAction={() => {
                            if (!(workInstruction && workInstruction.assignees && workInstruction.assignees > 0) && this.state.deletingWorkInstructionId) {
                                if (this.props.deleteWorkInstruction) {
                                    this.props.deleteWorkInstruction(this.state.deletingWorkInstructionId);
                                }
                                this.setState({ displayingDialogue: false, deletingWorkInstructionId: null });
                            } else if (this.state.deletingWorkInstructionId) {
                                this.setState({ displayingDialogue: false, deletingWorkInstructionId: null });
                            }
                        }}
                        cancel={() => this.setState({ displayingDialogue: false, deletingWorkInstructionId: null })}
                    />
                ) : null
            }


            <div id="wi-page-container-header">
                <h3 className="break-word">{workInstruction.title}</h3>
            </div>
            {!release || (release && isAssignable) ?
                <div id="wi-summary-actions-container" className="flex">
                    {release && isAssignable ?
                        <div id="wi-summary-action" className="flex-column-centered clickable" onClick={this.props.toggleAssignments}>
                            {ManageUsersIcon}
                        </div> : null}
                    <div id="wi-summary-action" className="flex-column-centered clickable"
                        onClick={(e) => this.props.cloneWorkInstruction(e, this.props.workInstruction._id)}>
                        {duplicateInstructionIcon}
                    </div>
                    <div id="wi-summary-action" className="flex-column-centered clickable"
                        onClick={(e) => this.editWorkInstruction(e, this.props.workInstruction._id,release,isAssignable,this.props.workInstruction.title)}>
                        {editInstructionIcon}
                    </div>
                    {/* <div id="wi-summary-action" className="flex-column-centered clickable"
                        onClick={(e) => this.previewWorkInstruction(e, this.props.workInstruction._id)}>
                        {previewInstructionIcon}
                    </div> */}
                    <div id="wi-summary-action" className="flex-column-centered clickable"
                        onClick={(e) => this.deleteWorkInstruction(e, this.props.workInstruction._id)}>
                        {deleteInstructionIcon}
                    </div>
                </div> :
                <div id="wi-summary-actions-container" style={{ marginTop: ".5em" }} className="flex-centered">
                    <div className="flex-centered">
                        <p style={{ marginRight: '.2em' }}>Building Work Instruction...</p>
                        {BuildClock}
                    </div>
                </div>}
            <div id="wi-summary-scroll" style={{ overflowY: "scroll", height: "100%" }}>
                <div className="flex-justify-center" style={{ padding: ".625em 0" }}>
                    {this.renderImage()}
                </div>
                <div id="toc-p-wrapper" className="max-height FontSize16">
                    {/* {assignedUsers.length > 0 ? <p className="underline" style={{ margin: ".5em" }}>Assigned Users</p> : null } */}
                    {/* {assignedUsers.length > 0 ? assignedUsers.map(user => {{
                        return <li key={user._id}>{`${user.name} ${user.role}`}</li>
                    }) : null} */}
                    <p style={{ margin: ".5em", textDecoration: "underline" }}>Publication Page</p>
                    <ul id="summary-publication-info" style={{ margin: "1em" }}>
                        {publicationPage ?
                            <Fragment>
                                <li key={`WI-Summary DocNum`} id="step-preview-description">
                                    <h3 id="summary-publication-category">{`Document Number: ${publicationPage.docNum || "N/A"}`}</h3>
                                </li>
                                <li key={`WI-Summary Created On`} id="step-preview-description">
                                    <h3 id="summary-publication-category">{`Created On: ${this.parseDate(this.props.workInstruction.creation_date)}`}</h3>
                                </li>
                                <li key={`WI-Summary Created By`} id="step-preview-description">
                                    <h3 id="summary-publication-category">{`Created By: ${publicationPage.createdBy || "N/A"}`}</h3>
                                </li>
                                <li key={`WI-Summary Modified-On`} id="step-preview-description">
                                    {/* <h3 id="summary-publication-category">{`Modified On: ${this.parseDate(this.props.workInstruction.modified_date) || "N/A"}`}</h3> */}
                                    <h3 id="summary-publication-category">{`Modified On: ${"N/A"}`}</h3>
                                </li>
                                <li key={`WI-Summary info-checks-requirement`} id="step-preview-description">
                                    <h3 id="summary-publication-category">{`Requires Info Page Checks: ${this.props.workInstruction.require_info_checks ? "Yes" : "No"}`}</h3>
                                </li>
                                <li key={`WI-Summary rescission-date`} id="step-preview-description">
                                    <h3 id="summary-publication-category">{`Recission Date: ${this.parseDate(publicationPage.rescissionDate) || "N/A"}`}</h3>
                                </li>
                                <li key={`WI-Summary identification-classification id-class`} id="step-preview-description">
                                    <h3 id="summary-publication-category">{`Identification / Classification: ${publicationPage.identificationAndClassification || "N/A"}`}</h3>
                                </li>
                                <li key={`WI-Summary system`} id="step-preview-description">
                                    <h3 id="summary-publication-category">{`System: ${publicationPage.system || "N/A"}`}</h3>
                                </li>
                                <li key={`WI-Summary identification-classification subsystem`} id="step-preview-description">
                                    <h3 id="summary-publication-category">{`Subsystem: ${publicationPage.subSystem || "N/A"}`}</h3>
                                </li>
                                <li key={`WI-Summary Subject`} id="step-preview-description">
                                    <h3 id="summary-publication-category">{`Subject: ${publicationPage.subject || "N/A"}`}</h3>
                                </li>
                                <li key="WI-Summary References" id="step-preview-description">
                                    <h3 id="summary-publication-category">References: </h3>
                                    <ul id="summary-publication-group">
                                        {publicationPage.references ? publicationPage.references.map((item, index) => {
                                            return <li key={index} id="summary-publication-item">{item}</li>
                                        }) : "N/A"}
                                    </ul>
                                </li>
                                <li key="WI-Summary Figures" id="step-preview-description">
                                    <h3 id="summary-publication-category">Figures: </h3>
                                    <ul id="summary-publication-group">
                                        {publicationPage.figures ?publicationPage.figures.map((item, index) => {
                                            return <li key={index} id="summary-publication-item">{item}</li>
                                        }) : "N/A"}
                                    </ul>
                                </li>
                                {/* <li key="WI-Summary Tables" id="step-preview-description">
                                    <h3 id="summary-publication-category">Tables: </h3>
                                    <ul id="summary-publication-group">
                                        {publicationPage.tables.map(item => {
                                            return <li id="summary-publication-item">{item}</li>
                                        }) || "N/A"}
                                    </ul>
                                </li> */}
                                <li key="WI-Summary Enclosures" id="step-preview-description">
                                    <h3 id="summary-publication-category">Enclosures: </h3>
                                    <ul id="summary-publication-group">
                                        {publicationPage.enclosures ? publicationPage.enclosures.map(item => {
                                            return <li id="summary-publication-item">{item}</li>
                                        }) : "N/A"}
                                    </ul>
                                </li>
                            </Fragment>
                            : <div style={{ margin: ".5m" }}> A publication page has not been created yet</div>}
                    </ul>
                    <p style={{ margin: "1em", textDecoration: "underline" }}>Table of Contents</p>
                    <ul id="summary-toc" style={{ height: "inherit" }}>

                        {this.props.workInstruction.steps && this.props.workInstruction.steps.length > 0 ?
                            <SortableTree
                                treeData={this.state.treeData}
                                onChange={treeData => this.setState({ treeData })}
                                canDrag={() => false}
                                canDrop={() => false}
                                key={({ node }) => node._id}
                                generateNodeProps={({ node, path }) => ({
                                    // Original onClick logic if any
                                    // onClick: () => this.props.selectStep(node, path),
                                    // className: this.props.currentStep === node ? 'selected-container' : null
                                })}
                                getNodeKey={({ node }) => node._id}
                                theme={Minimalistic}
                                searchQuery={null}
                                searchFocusOffset={0}
                                style={{ width: '100%' }}
                                rowHeight={36}
                                searchFinishCallback={matches =>
                                    this.setState({
                                        // Original state updates if any
                                        // searchFoundCount: matches.length,
                                        // searchFocusIndex:
                                        //     matches.length > 0 ? 0 % matches.length : 0,
                                    })
                                }
                             />
                            : <div style={{ marginLeft: "1em" }}>No steps defined.</div>}
                    </ul>
                </div>
            </div>
        </div>
    }
}

export default withRouter(WISummary)